import { createContext } from 'react';

const DarkModeContext = createContext({ theme: 'light' });

export default DarkModeContext;
